import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { faqs } from '../data/content';
import { PlusIcon } from './icons';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="w-full bg-white pb-20 lg:pb-28" data-id="element-156" data-mp="1lc1zxc2r31qn">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-157" data-mp="1gdh0vfz8io3s">
        <div className="grid gap-10 border-t border-navy-100 pt-16 lg:grid-cols-[minmax(0,4fr)_minmax(0,8fr)] lg:gap-16" data-id="element-158" data-mp="2e0fypu1ny239">
          <div data-id="element-159" data-mp="290tn1p1hgtwk">
            <h2 className="font-display text-3xl font-extrabold leading-tight tracking-tight text-navy-800" data-id="element-160" data-mp="292efn948m2rs">
              Straight answers to the questions everyone asks.
            </h2>
          </div>

          <dl className="divide-y divide-navy-100 border-y border-navy-100" data-id="element-161" data-mp="1z25int2f8dbc">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <div key={faq.question} data-id="element-162" data-mp="nniha03t7j6i" data-mpi={index}>
                  <dt data-id="element-163" data-mp="nmgu4x9ir68f">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left transition-colors duration-150 ease-out hover:text-sky-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-400" data-id="element-164" data-mp="nqd0xpf00zyv">
                      <span className="font-display text-lg font-semibold text-navy-800" data-id="element-165" data-mp="kkxuv7zwux29">
                        {faq.question}
                      </span>
                      <PlusIcon className={`mt-1 h-5 w-5 shrink-0 text-sky-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-166" data-mp="bj8321249w3y" />
                    </button>
                  </dt>
                  <AnimatePresence initial={false} data-id="element-167" data-mp="1t52nfso1fvl">
                    {isOpen && <motion.dd id={`faq-panel-${index}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.2,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-168" data-mp="3jy8dlh5bcm3x">
                        <p className="max-w-2xl pb-6 pr-10 text-[15px] leading-relaxed text-navy-500" data-id="element-169" data-mp="1koyn0gupydk8">
                          {faq.answer}
                        </p>
                      </motion.dd>}
                  </AnimatePresence>
                </div>;
          })}
          </dl>
        </div>
      </div>
    </section>;
}